var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0A10.261,10.261,0,0,0,1.75,10.25a10.156,10.156,0,0,0,3,7.236V21.25a2.749,2.749,0,0,0,5,1.58,2.748,2.748,0,0,0,4.5,0,2.749,2.749,0,0,0,5-1.58V17.486a10.157,10.157,0,0,0,3-7.236A10.261,10.261,0,0,0,12,0Zm2.25,10.25A2.25,2.25,0,1,1,16.5,12.5,2.25,2.25,0,0,1,14.25,10.25Zm-.5,6.868a.25.25,0,0,1-.22.132H10.467a.25.25,0,0,1-.208-.388l1.533-2.3a.249.249,0,0,1,.416,0l1.533,2.3A.25.25,0,0,1,13.753,17.118ZM5.25,10.25A2.25,2.25,0,1,1,7.5,12.5,2.25,2.25,0,0,1,5.25,10.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.7b744072ad9498dc7087cfde2137ce52.svg";
export { ForwardRef as ReactComponent };